/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */


window.corpBehaviours = window.corpBehaviours || {};
corpBehaviours.logOutBehaviour = {
    properties: {
        redirectUrl: {
            type: String,
            notify: true,
            value: ""
        },
        objData: {
            type: Object,
            notify: false,
            value: {
                header: {},
                data: {
                    "tenantId": sessionStorage.tenantId,
                    "remarks": getLabel('m_logoutSuccess')
                }
            }
        },
        username: {
            type: String,
            value: "",
            notify: true
        },
        rememberMe: {
            type: Boolean,
            value: false,
            notify: true
        },
        show: {
            type: Boolean,
            value: false,
            notify: true
        },
        acceptedTermsConditions: {
            type: Boolean,
            value: false,
            notify: true
        }
    },
    goToLoginPage: function () {
        var role = clientStorage.get(storageType.session, 'role');
        this.acceptedTermsConditions = false;
        this.skipLogoutAjaxcall = false;
        if((this.selected == 4) && (typeof (routerPolicy) != "undefined")) { 
        this.skipLogoutAjaxcall = true;
        }
        this.selected = 0;
        this.show = false;
        this.username = "";
        this.rememberMe = false;
        if (typeof this.parentElement.__dataHost.getRootNode().querySelector('ev-login').shadowRoot.getElementById('originalU') != undefined) {
            this.parentElement.__dataHost.getRootNode().querySelector('ev-login').shadowRoot.getElementById('originalU').invalid = false;
        }
        if ((typeof (routerPolicy) != "undefined") && routerPolicy.decideNavigation) {
            routerPolicy.decideNavigation({ url: '/login' }, function (e) {
            }, function (e) {
            });
        }
        if(sessionStorage["auth_token"]) {
            this.$.logoutAjax.url = "api/CBUsers/logout?=" + sessionStorage["auth_token"];
            if ((this.redirectUrl === "") && (!this.skipLogoutAjaxcall)) {
                this.$.logoutAjax.generateRequest();
            }
        } else {
            if (window.location.protocol == 'file:') {
                if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                    this.redirectUrl = localStorage.uibaseroute + "/index.html";
                    localStorage.tenantId = "";
                } else if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
                    this.redirectUrl = localStorage.uibaseroute + "/indexAdmin.html";
                }
            } else {
                if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
                    this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + localStorage.getItem("tenantId"); // clear tenant id from localstorage
                    localStorage.tenantId = "";
                }
            }
            location.href = this.redirectUrl;
        }
    },
    _handleError: function () {
        //alert("Error Occured while logging out.");
        //this.redirectUrl = localStorage.uibaseroute + "/index.html";
	//belwo Changes done for the multi entity
    	this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + sessionStorage.getItem("tenantId");
        sessionStorage.clear();
		performance.clearMeasures();
        location.href = this.redirectUrl;
    },
    _handleResponse: function (event) {
        //var response = event.detail.response;
        if (event.detail.status === 200 || event.detail.status === 204) {
            //console.log("Logged out successfully");
            if (typeof (OGAdapter) !== "undefined") {
                OGAdapter.logout();
            }
            // localStorage.tenantId = sessionStorage.tenantId;
            // var mainbody = document.getElementById("mainbody");
            var role = clientStorage.get(storageType.session, 'role');
            //changed below condition for the multientity feature .
            
            window.tenantId = sbEncrypt.encrypt(sessionStorage.tenantId);
            sessionStorage.clear();
			performance.clearMeasures();

      if (window.location.protocol == 'file:') {
        if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
          this.redirectUrl = localStorage.uibaseroute + "/index.html";
          localStorage.tenantId = "";
        } else if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) && role === "admin") {
          this.redirectUrl = localStorage.uibaseroute + "/indexAdmin.html";
        }
      } else {
        if (getNavigationItem("userAgent").match(/Android|webOS|iPhone|iPod|Blackberry|iPad/i) || role === "consumer" || role === "corporate") {
          this.redirectUrl = localStorage.uibaseroute + "?bank_id=" + sbEncrypt.decrypt(window.tenantId); // clear tenant id from localstorage

          localStorage.tenantId = "";
        }
      }
            location.href = this.redirectUrl;
        }
    }
}
